import { IconCircleCheckFilled, IconAlertTriangleFilled } from '@tabler/icons-react';

const FONT = '"Public Sans", sans-serif';

export default function StockBadge({ current, minimum }) {
  const ratio = minimum > 0 ? current / minimum : Infinity;

  let tone, IconComp, label;
  if (current <= minimum) {
    tone = { color: '#f87c2b', background: 'rgba(248, 124, 43, 0.12)' };
    IconComp = IconAlertTriangleFilled;
    label = 'Crítico';
  } else if (ratio < 1.5) {
    tone = { color: '#f87c2b', background: 'rgba(248, 124, 43, 0.12)' };
    IconComp = IconAlertTriangleFilled;
    label = 'Bajo';
  } else {
    tone = { color: '#30d158', background: 'rgba(48, 209, 88, 0.12)' };
    IconComp = IconCircleCheckFilled;
    label = 'OK';
  }

  return (
    <span
      className="inline-flex items-center justify-center gap-1.5"
      style={{
        backgroundColor: tone.background,
        borderRadius: '9999px',
        height: '28px',
        padding: '0 10px',
        fontSize: '12px',
        lineHeight: 1,
        fontFamily: FONT,
        color: tone.color,
        fontWeight: 600,
        letterSpacing: '-0.01em',
        whiteSpace: 'nowrap',
      }}
    >
      <IconComp size={13} color={tone.color} style={{ flexShrink: 0 }} />
      {label}
    </span>
  );
}
